<template>
  <div class="page">
    <div class="page__bd" v-if="customLoaded">
      <div class="form-preview weui-form-preview">
        <!-- <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">客户</label>
            <em class="weui-form-preview__value">{{initData.cu_name}}</em>
          </div>
        </div> -->
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料编号</label>
            <span class="weui-form-preview__value">{{initData.pr_code}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">厂家/品牌</label>
            <span class="weui-form-preview__value">{{initData.pr_brand}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料名称</label>
            <span class="weui-form-preview__value">{{initData.pr_detail}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">型号</label>
            <span class="weui-form-preview__value">{{initData.pr_orispeccode}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">规格</label>
            <span class="weui-form-preview__value">{{initData.pr_spec}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">物料类型</label>
            <span class="weui-form-preview__value">{{initData.pr_kind}}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">数量</label>
            <span class="weui-form-preview__value">{{initData.po_onhand}}{{initData.pr_unit}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="!isFieldHidden('items.po_avprice')">
            <label class="weui-form-preview__label" >成本单价（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.po_avprice}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="!isFieldHidden('items.po_amount')">
            <label class="weui-form-preview__label">成本金额（元）</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{initData.po_amount}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import listCustomization from "@/mixins/listCustomization.js";
export default {
  mixins: [listCustomization],
  props: {
    initData: Object
  },
  data() {
    return {
      params: {
        caller: 'ReserveCostReport',
        name: 'stock-stockdetail-stockdetail', 
      },
      show:false
    };
  }
};
</script>